<template>
    <section class="how-it-works">
        <div class="content-12 text-left py-5">
            <div class="container pt-lg-3">
                <h2 class="pricing-title">Precios por participante</h2>
                <p class="pricing-sub">
                    Planes accesibles para cualquier tamaño de organización
                </p>
                <table class="table pricing-table">
                    <thead>
                        <tr>
                            <th class="col-features">Características</th>
                            <th>0–250</th>
                            <th>251–500</th>
                            <th>501–1000</th>
                            <th>&gt; 1001</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="feature-label">Precio por usuario</td>
                            <td>
                                <span class="price-sign">$</span>
                                <span class="price-val">1.99</span>
                            </td>
                            <td colspan="3" class="contact-cell">
                                <a
                                    href="https://wa.me/50222927882"
                                    target="_blank"
                                >
                                    Comunícate con nosotros
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td class="feature-label">Logo personalizado</td>
                            <td><span class="dash">—</span></td>
                            <td>
                                <span class="check"
                                    ><i class="fas fa-check"></i
                                ></span>
                            </td>
                            <td>
                                <span class="check"
                                    ><i class="fas fa-check"></i
                                ></span>
                            </td>
                            <td>
                                <span class="check"
                                    ><i class="fas fa-check"></i
                                ></span>
                            </td>
                        </tr>
                        <tr>
                            <td class="feature-label">Banner interno</td>
                            <td><span class="dash">—</span></td>
                            <td>
                                <span class="check"
                                    ><i class="fas fa-check"></i
                                ></span>
                            </td>
                            <td>
                                <span class="check"
                                    ><i class="fas fa-check"></i
                                ></span>
                            </td>
                            <td>
                                <span class="check"
                                    ><i class="fas fa-check"></i
                                ></span>
                            </td>
                        </tr>
                        <tr>
                            <td class="feature-label">
                                Envío masivo de códigos
                            </td>
                            <td><span class="dash">—</span></td>
                            <td>
                                <span class="check"
                                    ><i class="fas fa-check"></i
                                ></span>
                            </td>
                            <td>
                                <span class="check"
                                    ><i class="fas fa-check"></i
                                ></span>
                            </td>
                            <td>
                                <span class="check"
                                    ><i class="fas fa-check"></i
                                ></span>
                            </td>
                        </tr>
                        <tr>
                            <td class="feature-label">
                                Backend administrativo
                            </td>
                            <td><span class="dash">—</span></td>
                            <td>
                                <span class="check"
                                    ><i class="fas fa-check"></i
                                ></span>
                            </td>
                            <td>
                                <span class="check"
                                    ><i class="fas fa-check"></i
                                ></span>
                            </td>
                            <td>
                                <span class="check"
                                    ><i class="fas fa-check"></i
                                ></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
</template>

<style scoped>
.pricing-title {
    text-align: center;
    font-size: 28px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 10px;
}

.pricing-sub {
    text-align: center;
    font-size: 14px;
    color: #6c757d;
    line-height: 1.6;
    margin-bottom: 1.5rem;
}

.pricing-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

/* Header verde */
.pricing-table thead tr th {
    background-color: #2e7d32;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    padding: 12px 14px;
    text-align: center;
    border: none;
}

.pricing-table thead tr th.col-features {
    background-color: #1b5e20;
    text-align: left;
    width: 32%;
}

/* Celdas del cuerpo */
.pricing-table tbody td {
    padding: 11px 14px;
    text-align: center;
    font-size: 13px;
    border: 0.5px solid #e0e0e0;
    vertical-align: middle;
}

.feature-label {
    text-align: left !important;
    font-size: 13px;
    color: #555;
    background-color: #f5f5f5;
    font-weight: 400;
}

/* Precio destacado */
.price-val {
    font-size: 34px;
    font-weight: 700;
    color: #f5a623;
    line-height: 1;
    vertical-align: middle;
}

.price-sign {
    font-size: 17px;
    font-weight: 400;
    color: #f5a623;
    vertical-align: super;
}

/* Celda "Comunícate con nosotros" */
.contact-cell {
    font-size: 13px;
    color: #555;
}

.contact-cell a {
    color: #2e7d32;
    font-weight: 500;
    text-decoration: none;
}

.contact-cell a:hover {
    text-decoration: underline;
}

/* Checkmark circular verde */
.check {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background-color: #2e7d32;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
}

/* Guión para sin feature */
.dash {
    color: #bdbdbd;
    font-size: 18px;
}

/* Nota al pie */
.footer-note {
    text-align: center;
    margin-top: 1rem;
    font-size: 13px;
    color: #6c757d;
}

.footer-note a {
    color: #2e7d32;
    font-weight: 500;
    text-decoration: none;
}

.footer-note a:hover {
    text-decoration: underline;
}

@media (max-width: 768px) {
    .price-val {
        font-size: 24px;
    }

    .price-sign {
        font-size: 13px;
    }

    .check {
        width: 18px;
        height: 18px;
        font-size: 10px;
    }

    .dash {
        font-size: 14px;
    }

    .pricing-table tbody td,
    .feature-label,
    .contact-cell {
        font-size: 11px;
        padding: 8px 6px;
    }

    .pricing-table thead tr th {
        font-size: 11px;
        padding: 10px 6px;
    }
}

@media (max-width: 480px) {
    .price-val {
        font-size: 18px;
    }

    .price-sign {
        font-size: 11px;
    }

    .check {
        width: 15px;
        height: 15px;
        font-size: 8px;
    }

    .dash {
        font-size: 12px;
    }

    .pricing-table tbody td,
    .feature-label,
    .contact-cell {
        font-size: 10px;
        padding: 6px 4px;
    }

    .pricing-table thead tr th {
        font-size: 10px;
        padding: 8px 4px;
    }
}
</style>
